import React, { useEffect, useState } from "react";

export const DropDown = ({
  list,
  dropdown_open,
  setdropdown_open,
  onclick,
  id,
  type,
}) => {
  window.onclick = () => {
    setdropdown_open("");
  };
  return (
    <div
      className="dropdown_options"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <input
        type="checkbox"
        name="global_filter"
        checked={dropdown_open == id ? true : false}
      />
      <label
        className="title"
        onClick={() => setdropdown_open((prev) => (prev == id ? "" : id))}
      >
        {type}
        <div className="arrow">
          <svg
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 451.847 451.847"
          >
            <g>
              <path
                d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"
                fill="#000000"
                opacity="1"
                data-original="#000000"
              ></path>
            </g>
          </svg>
        </div>
      </label>
      <div className="body">
        <div className="body_main">
          {list.map((option) =>
            option ? (
              <div
                className="options"
                onClick={() => {
                  //   setcurrent_filters((prev) => ({
                  //     ...prev,
                  //     [title]: prev[title].includes(option)
                  //       ? prev[title].filter((el) => el != option)
                  //       : [...prev[title], option],
                  //   }));
                  onclick(option);
                  setdropdown_open("");
                  //   setDropCtr("");
                }}
              >
                {option}
                <div
                  className="checkbox"
                  is_checked={type
                    .toLowerCase()
                    .includes(option.toLowerCase())
                    .toString()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="300"
                    height="218"
                    viewBox="0 0 300 218"
                    fill="none"
                  >
                    <path
                      d="M292.935 6.59995C284.401 -1.93338 271.601 -1.93338 263.068 6.59995L103.068 166.6L36.9346 100.467C28.4013 91.9333 15.6013 91.9333 7.06797 100.467C-1.46536 109 -1.46536 121.8 7.06797 130.333L88.1346 211.4C92.4013 215.667 96.668 217.8 103.068 217.8C109.468 217.8 113.735 215.667 118.001 211.4L292.935 36.4666C301.468 27.9333 301.468 15.1333 292.935 6.59995Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              ""
            )
          )}
        </div>
      </div>
    </div>
  );
};
// return (
//   <div
//     className={"dropdown_options " + (DropCtr ? " active" : "")}
//     onClick={(e) => e.stopPropagation()}
//   >
//     <div
//       className="dropdown_options_ctr"
//       onClick={() => {
//         setDropCtr((prev) => (prev != "" ? "" : id));
//       }}
//     >
//       {type}
//       <div className="arrow">
//         <svg
//           width="512"
//           height="512"
//           x="0"
//           y="0"
//           viewBox="0 0 451.847 451.847"
//         >
//           <g>
//             <path
//               d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"
//               fill="#000000"
//               opacity="1"
//               data-original="#000000"
//             ></path>
//           </g>
//         </svg>
//       </div>
//     </div>
//     <div className={"dropdown_options_list "}>
//       <div className="dropdown_options_box">
//         {list.map((el, i) => (
//           <div
//             key={i}
//             onClick={() => {
//               onclick(el);
//               setDropCtr("");
//             }}
//             className="options"
//           >
//             {el}
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );
